import React from "react";
import LoadingIndicator from "../components/LoadingIndicator";

interface IProps {
    bonus: number | undefined;
}

export default class BonusRound extends React.Component<IProps> {
    public render(): JSX.Element {
        const { bonus } = this.props;
        return (
            <div className="bonus-board">
                { bonus ? (
                    <div className="bonus">
                        <p>The draw bonus is..</p>
                        <div className="amount">{ bonus }x</div>
                    </div>
                ) : (
                    <div className="loading">
                        <div className="whole-screen-loading">
                            <p>Loading bonus..</p>
                            <div><LoadingIndicator /></div>
                        </div>
                    </div>
                ) }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/BonusBoard.tsx